import requestor from "../api/requestor";

export default {

    async getTotalOrder() {
        return await requestor._post('/client.Stat/getTotalOrder')
    },

    async getTotalUser() {
        return await requestor._post('/client.Stat/getTotalUser')
    },

    async getTotalMoney() {
        return await requestor._post('/client.Stat/getTotalMoney')
    },

    async getUser() {
        return await requestor._post('/client.Stat/getUser')
    },

    async getShopOrder() {
        return await requestor._post('/client.Stat/getShopOrder')   
    },

    async getTodayOrder() {
        return await requestor._post('/client.Stat/getTodayOrder')
    },

    async getAddress() {
        return await requestor._post('/client.Stat/getAddress')                     
    },

    async getFoods() {
        return await requestor._post('/client.Stat/getFoods')
    },

    async today() {
        return await requestor._post('/client.Stat/today')
    },

    async userCount() {
        return await requestor._post('/client.Stat/userCount')
    },

    async evaluation() {
        return await requestor._post('/client.Stat/evaluation')
    },

    async getDeliveryType() {
        return await requestor._post('/client.Stat/getDeliveryType')
    }
}